"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCountryFromValue;

var _ = require(".");

var _countries = _interopRequireDefault(require("../countries"));

function getCountryFromValue(isoCode, countries) {
  if (Array.isArray(countries) && countries.length > 0) {
    if (isoCode) {
      var _country = (0, _.findCountryByIsoCode)(isoCode, countries);

      if (_country) {
        return _country;
      }
    }

    var country = (0, _.findCountryByIsoCode)('us', countries);

    if (country) {
      return country;
    }

    return countries[0];
  }

  return (0, _.findCountryByIsoCode)('us', _countries["default"]);
}